import Translator from 'utils/translator';
import capitalize from 'utils/capitalize';

var TapTour, document;
document = window.document;
TapTour = (function() {
  function TapTour(options) {
    this._options = $.extend({
      steps: [],
      templates: {
                  modal: '<div class="modal fade in" tabindex="-2" role="dialog" style="display:block;"><div class="modal-dialog modal-wide"><div class="modal-content"><div class="modal-header"><h4 class="success"><span class="tapicon tapicon-rocket"></span> %TITLE%</h4></div><div class="modal-body">%BODY%</div><div class="modal-footer"><a class="btn btn-primary tour-next">Ok</a></div></div></div></div>',
                  arrow: {
                          bottomLeft: '<div class="f-l spaced-right spaced-top" style="width:40rem; background-color: rgba(253,253,253,0.95); border-radius:3px; padding: 2rem;"><h4 class="no-top-m success"><span class="tapicon tapicon-rocket"></span>%TITLE%</h4>%BODY%<div class="spaced-top t-right db"><a class="btn btn-primary tour-next">Ok</a></div></div><div class="f-l arrow"><img src="/bundles/tapsite/images/taptour/arrow-bl-to-tr.svg"></div>',
                          bottomRight: '<div class="f-l spaced-right arrow"><img src="/bundles/tapsite/images/taptour/arrow-br-to-tl.svg"></div><div class="f-l spaced-top" style="width:40rem; background-color: rgba(253,253,253,0.95); border-radius:3px; padding: 2rem;"><h4 class="no-top-m success"><span class="tapicon tapicon-rocket"></span>%TITLE%</h4>%BODY%<div class="spaced-top t-right db"><a class="btn btn-primary tour-next">Ok</a></div></div>',
                          bottom: '<div class="t-centered arrow"><img src="/bundles/tapsite/images/taptour/arrow-b-to-t.svg"></div><div class="spaced-top" style="width:40rem; background-color: rgba(253,253,253,0.95); border-radius:3px; padding: 2rem;"><h4 class="no-top-m success"><span class="tapicon tapicon-rocket"></span>%TITLE%</h4>%BODY%<div class="spaced-top t-right db"><a class="btn btn-primary tour-next">Ok</a></div></div>',
                          top: '<div class="spaced" style="width:40rem; background-color: rgba(253,253,253,0.95); border-radius:3px; padding: 2rem;"><h4 class="no-top-m success"><span class="tapicon tapicon-rocket"></span>%TITLE%</h4>%BODY%<div class="spaced-top t-right db"><a class="btn btn-primary tour-next">Ok</a></div></div><div class="t-centered arrow"><img src="/bundles/tapsite/images/taptour/arrow-t-to-b.svg"></div>',
                          topLeft: '<div class="f-l spaced-right" style="width:40rem; background-color: rgba(253,253,253,0.95); border-radius:3px; padding: 2rem;"><h4 class="no-top-m success"><span class="tapicon tapicon-rocket"></span>%TITLE%</h4>%BODY%<div class="spaced-top t-right db"><a class="btn btn-primary tour-next">Ok</a></div></div><div class="f-l arrow"><img src="/bundles/tapsite/images/taptour/arrow-tl-to-br.svg"></div>',
                          topRight: '<div class="f-l spaced-right arrow"><img src="/bundles/tapsite/images/taptour/arrow-tr-to-bl.svg"></div><div class="f-l" style="width:40rem; background-color: rgba(253,253,253,0.95); border-radius:3px; padding: 2rem;"><h4 class="no-top-m success"><span class="tapicon tapicon-rocket"></span>%TITLE%</h4>%BODY%<div class="spaced-top t-right db"><a class="btn btn-primary tour-next">Ok</a></div></div>'
                        },
                  popover: {
                          bottom: '<div class="popover fade bottom in db" style="width: 30rem; position:relative"><div class="arrow"></div><h3 class="popover-title">%TITLE%</h3><div class="popover-content">%BODY%<div class="clear"></div><div class="spaced-top t-right db"><a class="btn btn-primary tour-next">' + capitalize(Translator.trans("navigation.next", {}, 'TapSiteBundle')) + '</a></div></div></div>',
                        }
                }
    }, options);

    this._inited = false;
    this._stopped = false;
    setCurstepDefaults(this);
    this._transitioning = 0;
    this._fadeOutTime = 200;
    this._backDrop = $('<div class="modal-backdrop fade in" style="opacity:0;"></div>');
  }

  function setCurstepDefaults(self) {
    self._curStep = {};
    self._curStepIndex = -1;
    self._curStepNode = null;
    self._curStepNodeBackup = null;
    self._curStepHelperLayer = null;
  }

  TapTour.prototype.addStep = function(step) {
    this._options.steps.push(step);

    return this;
  };

  TapTour.prototype.init = function() {
    if (this._inited) return;

    this._bindHandlers();

    $("body").append(this._backDrop);

    this._inited = true;

    return this;
  };

  TapTour.prototype.start = function() {
    var self = this;

    this._stopped = false;
    this.init();
    this._transitioning++;

    this._backDrop.show().animate({opacity: ".5"}, function(){
      self._transitioning--;
      self.next();
    });

    return this;
  };

  TapTour.prototype.stop = function(skipCleanup) {
    var self = this;

    if (!skipCleanup) {
      cleanupCurStep(this);
    }

    this._curStepNode.fadeOut(this._fadeOutTime);

    this._stopped = true;
    setCurstepDefaults(this);

    this._backDrop.animate({opacity: "0"}, function() {
      $(this).hide();
      if (self._options.onTourStopped && typeof self._options.onTourStopped == "function") {
        self._options.onTourStopped();
      }
    });

    return this;
  };

  TapTour.prototype.previous = function() {
    if (this._stopped || this._transitioning) return;
    this._transitioning++;
    cleanupCurStep(this);

    this._curStepIndex--;
    var step = this._options.steps[this._curStepIndex];

    if (typeof step !== "undefined") {
      if (step.skipOnMobile && $(window).width() <= 768) {
        this.next();
      }
      this._curStep = step;
      this.showStep();
    } else {
      this.stop();
    }

    this._transitioning--;

    return this;
  };

  TapTour.prototype.next = function() {
    if (this._stopped || this._transitioning) return;

    this._transitioning++;
    cleanupCurStep(this);

    var prevStep = this._options.steps[this._curStepIndex];

    if (prevStep && typeof prevStep.onStepComplete == "function") {
      prevStep.onStepComplete(prevStep);
    }

    this._curStepIndex++;
    var step = this._options.steps[this._curStepIndex];

    if (typeof step !== "undefined") {
      if (step.skipOnMobile && $(window).width() <= 768) {
        this.next();
      }
      this._curStep = step;
      this.showStep();
    } else {
      this.stop(true);
    }

    this._transitioning--;

    return this;
  };

  TapTour.prototype.showStep = function() {
    var self = this;
    var step = this._curStep;

    if (step == "undefined") {
      throw "Step " + i + " does not exist";
    }

    if (typeof step.onBeforeShow == "function") {
      step.onBeforeShow(step);
    }

    var template = getTemplate(step, self);

    var title = step.title || '';
    var body = step.body || '';

    template = template.replace(/%TITLE%/g, title);
    template = template.replace(/%BODY%/g, body);

    var $template = $('<div>' + template + '</div>');

    var buttonText;

    if (step.buttonText) {
      buttonText = step.buttonText;
    } else {
      buttonText = (this._curStepIndex === (this._options.steps.length - 1)) ? 'Ok' : capitalize(Translator.trans("navigation.next", {}, 'TapSiteBundle'));
    }

    $template.find('.tour-next').html(buttonText);

    if (!self._curStepNode) {
      showTemplate(step, $template, self);
    } else {
      this._transitioning++;
      self._curStepNode.fadeOut(this._fadeOutTime, function(){
        self._transitioning--;
        $(this).remove();
        showTemplate(step, $template, self);
        scrollToElement();
      });
    }

    function scrollToElement() {
      if (self._curStepNode && step.element && !isElementInViewport($(step.element))) {
          $("html, body").animate({ scrollTop: $(step.element).offset().top - self._curStepNode.outerHeight() - 20 }, 1000);
      }
    }

    return this;
  };

  /**
   * Private and helper methods
   */
  TapTour.prototype._bindHandlers = function() {
    var self = this;

    // Next Click Handler
    $(document.body).on('click', '.tour-next', function(){
      self.next();
    });

    // Resize Handler
    $(window).on('resize', function(){
      resizeHandler(self);
    });

    // Keyboard input handler
    document.onkeydown = function(evt) {
        evt = evt || window.event;
        switch (evt.keyCode) {
            case 37: // Left Arrow
                self.previous();
                break;
            case 39: // Right Arrow
                self.next();
                break;
            case 27: // Esc
                self.stop();
                break;
        }
    };

    $(window).on('scroll', scrollHandler);

    function scrollHandler() {
      if (!self._curStep.fixed) return;
      positionFixParent();
      positionHelperLayer(self._curStepHelperLayer, self._curStep, self);
      positionTemplate(self._curStep, self);
    };

    return this;
  };

  function resizeHandler(self) {
      positionTemplate(self._curStep, self);
      positionHelperLayer(self._curStepHelperLayer, self._curStep, self);
      manageTemplateVisibility(self);

      if (self._curStep.skipOnMobile && $(window).width() <= 768) {
        self.next();
      }
  }

  function _getPropValue (element, propName) {
    var propValue = '';
    if (element.currentStyle) {
      propValue = element.currentStyle[propName];
    } else if (document.defaultView && document.defaultView.getComputedStyle) { //Others
      propValue = document.defaultView.getComputedStyle(element, null).getPropertyValue(propName);
    }

    if (propValue && propValue.toLowerCase) {
      return propValue.toLowerCase();
    } else {
      return propValue;
    }
  }

  function cleanupCurStep(self) {
      if (self._curStepHelperLayer) {
        self._transitioning++;
        self._curStepHelperLayer.fadeOut(self._fadeOutTime, function(){
          $(this).remove();
          self._transitioning--;
        });
      }

      if (self._curStep.fixed) {
        removeFixParent();
      }

      if (self._curStep.element) {
        putElementBack(self._curStep, self);
      }
  }

  // showStep helper methods
  function addFixParent(targetElement) {
      var parentElm = targetElement.parentNode;
      while (parentElm !== null) {
        if (parentElm.tagName.toLowerCase() === 'body') break;
        var zIndex = _getPropValue(parentElm, 'z-index');
        var opacity = parseFloat(_getPropValue(parentElm, 'opacity'));
        var transform = _getPropValue(parentElm, 'transform') || _getPropValue(parentElm, '-webkit-transform') || _getPropValue(parentElm, '-moz-transform') || _getPropValue(parentElm, '-ms-transform') || _getPropValue(parentElm, '-o-transform');
        if (/[0-9]+/.test(zIndex) || opacity < 1 || transform !== 'none') {
          parentElm.className += ' taptour-fixParent';
          parentElm.setAttribute('data-top', getComputedStyle(parentElm).getPropertyValue("top"));
          positionFixParent();
        }

        parentElm = parentElm.parentNode;
      }
  }

  function removeFixParent() {
    var fixParents = document.querySelectorAll('.taptour-fixParent');
    if (fixParents && fixParents.length > 0) {
      for (var i = fixParents.length - 1; i >= 0; i--) {
        fixParents[i].className = fixParents[i].className.replace(/taptour-fixParent/g, '').replace(/^\s+|\s+$/g, '');
        var top = fixParents[i].getAttribute('data-top');
        if (top) {
          fixParents[i].style.setProperty('top', top);
        }
      }
    }
  }

  function positionFixParent() {
    var $fp = $('.taptour-fixParent');
    if ($fp) {
      var scrollTop = $('body').scrollTop();
      var top = parseInt($fp.data('top'));
      scrollTop = (scrollTop >= 0) ? scrollTop + top : top;
      $fp.css('top', top);
    }
  }

  function putElementBack(step, self) {
    $(step.element).replaceWith(self._curStepNodeBackup);
  }

  function backupElement(step, self) {
    self._curStepNodeBackup = $(step.element).clone();
  }

  function getTemplate(step, self) {
    if (step.template) return step.template;

    if (typeof step.type == "undefined") {
      return self._options.templates["modal"];
    }

    if (step.type == "modal") {
      return self._options.templates[step.type];
    } else if (step.type == "arrow" || step.type == "popover") {
      if (typeof step.position == "undefined") {
        throw "Missing Position for this template";
      }

      var templates = self._options.templates[step.type];

      if(templates.hasOwnProperty(step.position)) {
        return templates[step.position];
      } else {
        throw "Unsupported position: " + step.position;
      }
    } else {
      throw "Unsupported type: " + step.type;
    }
  }

  function positionHelperLayer(_helperLayer, step) {
    if (!step.element) return;

    var helperPadding = (typeof step.helperPadding !== "undefined") ? step.helperPadding : 4;
    var position = $(step.element).offset();
    var height = $(step.element).outerHeight();
    var width = $(step.element).outerWidth();

    _helperLayer
      .css('height', height + helperPadding)
      .css('width', width + helperPadding)
      .css('top', position.top - (helperPadding / 2))
      .css('left', position.left - (helperPadding / 2));
  }

  function positionTemplate(step, self) {
    if (!step.element || !step.position) return;

    var position = $(step.element).offset();
    var height = $(step.element).outerHeight();
    var width = $(step.element).outerWidth();
    var templateMarginTop = 20;

    var left, top;

    switch (step.position) {
      case "topLeft":
        left = position.left - self._curStepNode.outerWidth();
        top = position.top - height - (templateMarginTop * 2);
        break;

      case "top":
        left = position.left + (width / 2) - (self._curStepNode.outerWidth(true) / 2);
        top = position.top - self._curStepNode.outerHeight() - templateMarginTop;
        break;

      case "topRight":
        left = position.left + width; // - (width / 2)
        top = position.top - height;
        break;

      case "bottomLeft":
        left = position.left - self._curStepNode.outerWidth();
        top = position.top + height + templateMarginTop;
        break;

      case "bottom":
        left = position.left + (width / 2) - (self._curStepNode.outerWidth(true) / 2);
        top = position.top + height + templateMarginTop;
        break;

      case "bottomRight":
        left = position.left + width; // - (width / 2)
        top = position.top + height + templateMarginTop;
        break;
    }

    var elBottom = top + self._curStepNode.outerHeight();
    var winHeight = $(window).outerHeight();
    if (elBottom > winHeight) {
      var subtract = elBottom - winHeight + 20;
      top -= subtract;
      self._curStepNode.find('.arrow img').css('visibility', 'hidden');
    } else {
      self._curStepNode.find('.arrow img').css('visibility', 'visible');
    }

    self._curStepNode
                .css('top', top)
                .css('left', left);
  }

  function setTemplateCss(self) {
    self._curStepNode.first()
              .css('position', 'absolute')
              .css('z-index', 1040);

    if (!self._curStepNode.first().css('visibility')) {
        self._curStepNode.first().css('visibility', "hidden");
    }

    var templateCss = self._curStep.templateCss || {};

    for (var item in templateCss) {
      if(templateCss.hasOwnProperty(item)){
        self._curStepNode.first().css(item, templateCss[item]);
      }
    }

    var templateInnerCss = self._curStep.templateInnerCss || {};

    for (var item in templateInnerCss) {
      if(templateInnerCss.hasOwnProperty(item)){
        self._curStepNode.children().eq(1).css(item, templateInnerCss[item]);
      }
    }

    if (self._curStep.type == "arrow") {
      var arrowCss = self._curStep.arrowCss || {};

      for (var item in arrowCss) {
        if(arrowCss.hasOwnProperty(item)){
          self._curStepNode.children('.arrow').css(item, arrowCss[item]);
        }
      }
    }
  }

  function setElementCss(step) {
    $(step.element)
                  .css('z-index', 9999)
                  .css('position', 'relative');

    var elementCss = step.elementCss || {};

    for (var item in elementCss) {
      if(elementCss.hasOwnProperty(item)){
        $(step.element).css(item, elementCss[item]);
      }
    }

    var childCss = step.childCss || [];

    for (var i = childCss.length - 1; i >= 0; i--) {
      var item = childCss[i];
      var $el = $(step.element).find(item.element);
      if ($el) {
        for (var prop in item.css) {
          if(item.css.hasOwnProperty(prop)){
            $el.css(prop, item.css[prop]);
          }
        }
      }
    }
  }

  function manageTemplateVisibility(self) {
    if (!isElementFullyVisibleHorizontally(self._curStepNode)) {
      self._curStep.templateCss = {"width": "90%", left: "5%"};
      self._curStep.templateInnerCss = {"width": "100%"};
      self._curStep.arrowCss = {"display": "none"};

      if (self._curStep.position != "bottom") {
        self._curStepNode.remove();

        if (self._curStepHelperLayer) {
          self._curStepHelperLayer.remove();
        }

        self._curStep.position = "bottom";
        self.showStep();

        return true;
      } else {
        setTemplateCss(self);
      }
    }

    return false;
  }

  function showTemplate(step, $template, self) {
    if (step.element) {
      self._curStepNode = $template;
      setTemplateCss(self);

      $('body').append(self._curStepNode);

      positionTemplate(step, self);

      var willRebuild = manageTemplateVisibility(self)
      if (willRebuild) {
        return;
      }

      self._curStepNode.css('visibility', 'visible');

      backupElement(step, self);
      setElementCss(step, self);

      if (step.fixed) {
        addFixParent($(step.element)[0]);
      }

      var $helperLayer = $('<div></div>')
                        .css('position', 'absolute')
                        .css('z-index', 9998)
                        .css('background-color', 'rgba(253, 253, 253, 0.3)')
                        .css('border-radius', '3px');

      positionHelperLayer($helperLayer, step);
      $('body').append($helperLayer);

      self._curStepHelperLayer = $helperLayer;
    } else {
      self._curStepNode = $template;
      $('body').append(self._curStepNode);
    }
  }

  function isElementInViewport (el) {
      if (typeof jQuery === "function" && el instanceof jQuery) {
          el = el[0];
      }

      var rect = el.getBoundingClientRect();

      return (
          rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /*or $(window).height() */
          rect.right <= (window.innerWidth || document.documentElement.clientWidth) /*or $(window).width() */
      );
  }

  function isElementFullyVisibleHorizontally(el) {
      var rect = {
                  left: el.offset().left,
                  right: el.offset().left + el.width()
                };

      return (
          rect.left >= 0 &&
          rect.right <= (window.innerWidth || document.documentElement.clientWidth) /*or $(window).width() */
      );
  }

  return TapTour;
})();

module.exports = TapTour;
